// extracted by mini-css-extract-plugin
module.exports = {"lcard":"payconfirm_lcard__3rSdO","rcard":"payconfirm_rcard__1g7yJ"};